<template>
  <div>
    <!--<lxm-nav :title="'羊宝宝和小兔兔的展览筹款'" :share="true"></lxm-nav>-->
    <!--<lxm-nav></lxm-nav>-->
    <transition :name="transitionName" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  import LxmNav from '../common/LxmNav.vue'
  export default {
    components: {
      LxmNav
    },
    computed: {
      transitionName () {
        return this.$store.getters.transitionName
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?5c5b44e2